<p-toast key="scheduled-call-offer" position="top-right" styleClass="cx-scheduled-call-offer-toast">
  <ng-template let-message #message>
    @if (offer(); as offer) {
      <div
        class="scheduled-call-offer-toast d-flex align-items-center gap-3 w-100"
        (click)="$event.stopPropagation()">
        <div class="scheduled-call-offer-toast-info d-flex flex-column gap-1 flex-grow-1" aria-live="assertive">
          <div class="d-flex align-items-center gap-2">
            <span class="scheduled-call-offer-toast-dot flex-shrink-0 rounded-circle" aria-hidden="true"></span>
            <span class="scheduled-call-offer-toast-title fw-bold text-truncate">
              {{ 'AgentDesktop::ScheduledCall:ToastTitle' | abpLocalization }}
            </span>
            <span
              class="scheduled-call-offer-toast-seconds ms-auto flex-shrink-0 px-2 rounded-pill small fw-semibold"
              aria-live="off">
              {{ 'AgentDesktop::ScheduledCall:ToastSeconds' | abpLocalization: remainingSecondsText() }}
            </span>
          </div>
          @if (offer.contactName; as contactName) {
            <div class="scheduled-call-offer-toast-name fw-bold text-truncate">{{ contactName }}</div>
          }
          <div
            class="scheduled-call-offer-toast-phone text-truncate"
            [class.fw-bold]="!offer.contactName"
            [class.scheduled-call-offer-toast-phone--title]="!offer.contactName">
            {{ offer.phoneNumber | displayPhoneNumber }}
          </div>
          <div class="scheduled-call-offer-toast-scheduled d-flex align-items-center gap-1 small fw-semibold">
            <i class="pi pi-history" aria-hidden="true"></i>
            <span class="text-truncate">{{ offer.scheduledAtUtc | displayDateTime }}</span>
          </div>
        </div>
        <div class="d-flex gap-2 flex-shrink-0">
          <button
            type="button"
            class="toast-action-btn ad-call-action-accept scheduled-call-offer-toast-take"
            [attr.aria-label]="'Campaign::Panel:Take' | abpLocalization"
            [pTooltip]="'Campaign::Panel:Take' | abpLocalization"
            tooltipPosition="bottom"
            appendTo="body"
            tooltipStyleClass="scheduled-call-offer-toast-tooltip"
            (click)="onTake()">
            <i class="pi pi-check" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="toast-action-btn ad-call-action-decline scheduled-call-offer-toast-abandon"
            [attr.aria-label]="'Campaign::Bcw:Abandon' | abpLocalization"
            [pTooltip]="'Campaign::Bcw:Abandon' | abpLocalization"
            tooltipPosition="bottom"
            appendTo="body"
            tooltipStyleClass="scheduled-call-offer-toast-tooltip"
            (click)="onAbandon()">
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
  </ng-template>
</p-toast>
